import { Name } from "../Name";
import { system } from "../system";
export var Restriction;
(function (Restriction) {
    function convert(restriction) {
        const { verify, condition, allowed } = getVerifier(...restriction);
        return allowed ? [verify, condition, Name.fromNumber(allowed)] : [verify, condition];
    }
    Restriction.convert = convert;
    function getVerifier(...[category, ...restriction]) {
        const verifiers = {
            integer: system.Number.isInteger,
            positive: value => value > 0,
            negative: value => value < 0,
            minimum: value => value >= restriction[0],
            greater: value => value > restriction[0],
            maximum: value => value <= restriction[0],
            less: value => value < restriction[0],
            range: value => value >= restriction[0] && value <= restriction[1],
            within: value => value > restriction[0] && value < restriction[1],
            value: Array.isArray(restriction[0])
                ? value => restriction[0].some(v => v == value)
                : value => restriction.some(v => v == value),
        };
        return {
            verify: verifiers[category],
            condition: category +
                (restriction.length > 1
                    ? `: [${restriction.join(", ")}]`
                    : restriction.length == 1
                        ? `: ${restriction[0]}`
                        : ""),
            allowed: category == "value" ? restriction : undefined,
        };
    }
    Restriction.getVerifier = getVerifier;
})(Restriction || (Restriction = {}));
//# sourceMappingURL=Restriction.js.map